/**
 * 题目表单
 * @author mll
 * @description 新增/编辑的题目表单
 * @Date 2020/1/22
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from '../../../../tool';
import { SubjectForm } from '../../../../components'
import QuestionCategorySelect from '../../../online/bankQuestion/questionCategorySelect/questionCategorySelect';
let { WizContainer } = framework_tool;
let { WizForm, WizInput, WizIcon } = component_tool

class SubForm extends WizContainer {

    componentName = 'SubForm';

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    /**
     * 提交方法
     */
    onSubmit = (values) => {
        log.info('onSubmit:',values)
    }



    _render() {
        return <SubjectForm submit={this.onSubmit} treeSelectList={QuestionCategorySelect}/>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
};

export default connect(mapStateToProps)(SubForm);
